import { Outlet } from 'react-router-dom';
import Box from '@mui/material/Box';

export function ErrorLayout() {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 2,
      }}
    >
      <Outlet />
    </Box>
  );
}
